// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IColor {
  red: number;
  green: number;
  blue: number;
  alpha?: number;
}
